// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"540a2a21","79":"4a103a84","453":"c00ab7f6","703":"dfa8abe5"}[chunkId] + ".chunk.js";
};